import SwiperSlider from "../base";

const selectors = {
  sliderEl: "data-comp-gallery-slider",
  thumbnails: "data-thumbnail-trigger",
  nextEl: "[data-navigation-next-el]",
  prevEl: "[data-navigation-prev-el]",
  counter: "[data-image-gallery-counter]",
};

const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  speed: 600,
  preventClicks: false,
  preventClicksPropagation: false,
  navigation: {
    nextEl: selectors.nextEl,
    prevEl: selectors.prevEl,
  },
};

export default class GallerySlider extends SwiperSlider {
  static loaderPriority = "idle";
  static selector = `[${selectors.sliderEl}]`;
  constructor(containerEl) {
    super(containerEl);
    this.imageGallerySlider = new this.Swiper(this.$container, swiperOptions);
    this.nextEl = this.$container.querySelector(selectors.nextEl);
    this.prevEl = this.$container.querySelector(selectors.prevEl);
    this.counter = this.$container.querySelector(selectors.counter);
    this.sliderId = this.$container.getAttribute(selectors.sliderEl);
    this.thumbnails = document.querySelectorAll(
      `[${selectors.thumbnails}="${this.sliderId}"]`
    );
    this.addListeners();
  }

  addListeners() {
    this.addSlideChangeListener();
    this.addOnUnloadListener();
    this.addThumbnailSlideListeners();
  }

  addSlideChangeListener() {
    this.slideChange = this.slideChange.bind(this);
    this.imageGallerySlider.on("slideChange", this.slideChange);
  }

  slideChange() {
    dispatchResizeEvent();
    this.updateSlideCounter();
  }

  updateSlideCounter() {
    this.counter.innerHTML = this.imageGallerySlider.activeIndex + 1;
  }

  addThumbnailSlideListeners() {
    this.thumbnails.forEach((thumbnail, index) => {
      this.imageGallerySlideTo[index] = this.imageGallerySlideTo.bind(
        this,
        index
      );
      thumbnail.addEventListener("click", this.imageGallerySlideTo[index]);
    });
  }

  imageGallerySlideTo(index) {
    this.imageGallerySlider.slideTo(index);
  }

  addOnUnloadListener() {
    window.onunload = () => {
      this.removeSlideChangeListener();
      this.removeThumbnailSlideListeners();
    };
  }

  removeSlideChangeListener() {
    this.imageGallerySlider.off("slideChange", this.slideChange);
  }

  removeThumbnailSlideListeners() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.removeEventListener("click", this.imageGallerySlideTo[index]);
    });
  }
}

function dispatchResizeEvent() {
  window.dispatchEvent(new Event("resize"));
}
